import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { get2ColumnsWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/columnCalculator';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { PARAGRAPH_VERTICAL_PADDING } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.figma';
import { getTextBlockSize } from '@Utils/3d';

export function descriptionTextSize(
  titleProps: Omit<CardTextProps, 'text'>,
  paragraphProps: Omit<CardTextProps, 'text'>,
  internalMargin: number
) {
  return async (viewData: ViewData) => {
    const maxWidth = get2ColumnsWidth(viewData);

    const [titleSize, paragraphSize] = await Promise.all([
      getTextBlockSize({
        ...titleProps,
        maxWidth,
        text: viewData.modelData.header.title ?? '',
      }),
      getTextBlockSize({
        ...paragraphProps,
        maxWidth,
        text: viewData.modelData.header.text ?? '',
      }),
    ]);

    const numberOfParagraphs =
      viewData.modelData.header.text?.split('\n').length ?? 0;
    const additionalParagraphHeight =
      numberOfParagraphs * (PARAGRAPH_VERTICAL_PADDING * 2);

    return {
      width: maxWidth,
      height:
        titleSize.height +
        paragraphSize.height +
        internalMargin +
        additionalParagraphHeight,
    };
  };
}

export function heroDescriptionTextSize(
  titleProps: Omit<CardTextProps, 'text'>,
  paragraphProps: Omit<CardTextProps, 'text'>,
  internalMargin: number
) {
  return async (viewData: ViewData) => {
    const maxWidth = get2ColumnsWidth(viewData);

    const [titleSize, paragraphSize] = await Promise.all([
      getTextBlockSize({
        ...titleProps,
        maxWidth,
        text: viewData.modelData.header.heroImageTitle ?? '',
      }),
      getTextBlockSize({
        ...paragraphProps,
        maxWidth,
        text: viewData.modelData.header.heroImageText ?? '',
      }),
    ]);

    return {
      width: maxWidth,
      height: titleSize.height + paragraphSize.height + internalMargin,
    };
  };
}
